import { Machine, sendParent } from 'xstate';
function timeout(length) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, length);
    });
}
const notificationMachine = Machine({
    initial: 'summoned',
    id: 'notification',
    states: {
        summoned: {
            invoke: {
                id: 'entering',
                src: () => timeout(10),
                onDone: {
                    target: 'entering'
                }
            },
            on: {
                REMOVE: { target: 'exiting' }
            }
        },
        entering: {
            on: {
                REMOVE: { target: 'exiting' }
            },
            invoke: {
                id: 'entering',
                src: context => timeout(context.autoCloseAfter || 1600 / 2),
                onDone: [
                    {
                        target: 'idle.persisting',
                        cond: context => context.autoCloseAfter === 0
                    },
                    { target: 'idle.expiring' }
                ]
            }
        },
        idle: {
            on: {
                REMOVE: { target: 'exiting' }
            },
            states: {
                expiring: {
                    invoke: {
                        id: 'idling',
                        src: context => timeout(context.autoCloseAfter),
                        onDone: {
                            target: '#notification.exiting'
                        }
                    }
                },
                persisting: {}
            }
        },
        exiting: {
            invoke: {
                id: 'exiting',
                src: context => timeout((context.autoCloseAfter || 1600) / 4),
                onDone: {
                    actions: [
                        sendParent((ctx) => {
                            return { type: 'NOTIFICATION.REMOVED', id: ctx.id };
                        })
                    ]
                }
            }
        }
    }
});
export { notificationMachine };
//# sourceMappingURL=notificationMachine.js.map